<template>
  <div>
    <div class="print-header">
      <div class="body-content" style="font-size: 20px;" v-if="title">
        <div>
          <table style="width: 100%;">
            <tr>
              <td style="width: 35%;" v-if="schoolName">{{schoolName}}</td>
              <td style=" text-align: center;">
                <span style="text-align: center; display: inline-block; margin: 10px 0;">
                    <p v-if="title"><b> {{title}} </b></p></span>
              </td>
              <td style="width: 35%; text-align: center;"></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Lang from "../../lang";
import {mapState} from "vuex";

export default {
  name: "PrintReportHeader",
  props: {
    title: {
      type: [String],
      required: false
    },
    schoolName: {
      type: [String],
      required: false,
      default:'',
    },
    academic_year: {
      type: [String],
      required: false
    },

  },
  computed: {
    ...mapState("users", ["user"]),

    school() {
      return this.user.school;
    },
  }
}
</script>

<style>
  .print-header{display: none;}
</style>